import { ordering } from "keys";
import { isArray, isEmpty } from "lodash";

const setFilters = ({ page, search, pageSize = 15, sorting, model, customModel }) => {
    let params = {}

    if (page)
        params.page = page

    if (pageSize)
        params.page_size = pageSize

    if (search) {
        const encodedQuery = btoa(unescape(encodeURIComponent(search))); // Base64 encoding
        params.search = encodedQuery
    }

    if (!isEmpty(sorting)) {
        const { id, desc, fields } = sorting[0]

        // fields = 'first_name,last_name'
        if (fields) {
            if (desc)
                params.o = `-${fields}`
            else
                params.o = fields
        }


        else {
            let orderKey = ordering[model]?.[id] || id
            if (customModel)
                orderKey = customModel?.[id] || id

            // התיקון: אם זה מיון יורד, נוסיף מינוס
            if (desc)
                params.o = `-${orderKey}`
            else
                params.o = orderKey
        }

    }

    return params
}

export default setFilters